import { isShippingRequestStatus } from "../shared/shipping-request-status";

interface RepairInstockOrder {
  id: string;
  name: string;
  recordType: string;
  repairInstockDate: string;
  csOrderStatus: string;
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  })[character]!);
}

export function canRecordRepairInstockDate(
  order: RepairInstockOrder,
  busy: boolean,
  readOnly: boolean,
): boolean {
  return !busy && !readOnly
    && (order.recordType === "order" || order.recordType === "after-alteration")
    && !order.repairInstockDate.trim()
    && !isShippingRequestStatus(order.csOrderStatus)
    && order.csOrderStatus !== "非表示済";
}

export function repairInstockDateCell(
  order: RepairInstockOrder,
  dateLabel: string,
  busy: boolean,
  readOnly: boolean,
  saving: boolean,
): string {
  const disabled = !canRecordRepairInstockDate(order, busy, readOnly);
  const title = order.repairInstockDate.trim()
    ? "記録済みです。日付の変更・リセットは「記録内容修正」から行えます。"
    : readOnly ? "履歴では入荷日を記録できません。"
      : "この注文の後直し入荷日に本日の日付を記録します。";
  return `<span class="repair-instock-date-cell">
    <span class="repair-instock-date-value">${escapeHtml(dateLabel)}</span>
    <button type="button" class="button repair-instock-button${saving ? " is-saving" : ""}"
      data-repair-instock-order="${escapeHtml(order.id)}"
      aria-label="${escapeHtml(order.name)}の後直し入荷日を記録"
      aria-busy="${saving}" title="${escapeHtml(title)}" ${disabled ? "disabled" : ""}>${saving ? "記録中…" : "入荷済み"}</button>
  </span>`;
}
